import React, { Component } from 'react';
import { Map, TileLayer, Tooltip, GeoJSON, Marker } from 'react-leaflet';
import { BoxZoomControl } from 'react-leaflet-box-zoom';
import Button from 'antd/lib/button';
import Popover from 'antd/lib/popover';
// import { STREET_VIEW_TILE, STREET_VIEW_TILE_LIGHT } from 'app/constants';
import { setFeatureColor, renderTooltipContent } from './mapUtils';
import CustomMapControl from './CustomMapControl';
import azBoundary from './AZCounties.json'
import L, { LatLng } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './leafletMap.css';
// import * as scale from "d3-scale";
import Legend from "./Legend";

import accomodation from 'app/assets/maps_icons/accomodation.png'
import education from 'app/assets/maps_icons/education.png'
import finance from 'app/assets/maps_icons/finance.png'
import forestry from 'app/assets/maps_icons/forestry.png'
import homeland_security from 'app/assets/maps_icons/homeland_security.png'
import mining from 'app/assets/maps_icons/mining.png'
import physical_science from 'app/assets/maps_icons/physical_science.png'
import resource_and_conservation from 'app/assets/maps_icons/resource_and_conservation.png'
import transportation from 'app/assets/maps_icons/transportation.png'
import utilities from 'app/assets/maps_icons/utilities.png'
import wholesale_trade from 'app/assets/maps_icons/wholesale_trade.png'
import astro from 'app/assets/maps_icons/astro.png'
import metallurgical from 'app/assets/maps_icons/metallurgical.png'
import fine_arts from 'app/assets/maps_icons/mis.fine_arts.png'
import physiology from 'app/assets/maps_icons/physiology.png'
import default_icon from 'app/assets/maps_icons/default_icon.png'

import culinary from 'app/assets/maps_icons/culinary.png'
import militatry_tech from 'app/assets/maps_icons/militatry_tech.png'
import construction from 'app/assets/maps_icons/construction.png'
import natural_resouces from 'app/assets/maps_icons/natural_resouces.png'
import technicians from 'app/assets/maps_icons/technicians.png'
import transportation_of_materials from 'app/assets/maps_icons/transportation_of_materials.png'
import security_and_protection from 'app/assets/maps_icons/security_and_protection.png'
import library from 'app/assets/maps_icons/library.png'

import government from 'app/assets/maps_icons/government.png'
import mechanic_and_repair from 'app/assets/maps_icons/mechanic.png'
import business from 'app/assets/maps_icons/business.png'
import health from 'app/assets/maps_icons/health.png'
import precision_production from 'app/assets/maps_icons/precision production.png'
import liberal from 'app/assets/maps_icons/liberal.png'


const ICONS_MAPPING = {
  "Government": government,
  "Mechanic And Repair Technologies/Technicians": mechanic_and_repair,
  "Natural Resources And Conservation": natural_resouces,
  "Science Technologies/Technicians": technicians,
  "Business, Management, Marketing, And Related Support Services": business,
  "Health Professions And Related Programs": health,
  "Precision Production": precision_production,
  "Liberal Arts And Sciences, General Studies And Humanities": liberal,
  "Military Technologies And Applied Sciences": militatry_tech,
  "Accommodation and Food Services": accomodation,
  "default_icon": default_icon,
  "Astronomy And Astrophysics": astro,
  "Finance and Insurance": finance,
  "Agriculture, Forestry, Fishing and Hunting": forestry,
  "homeland_security": homeland_security,
  "Mining, Quarrying, and Oil and Gas Extraction": mining,
  "Mining And Mineral Engineering": mining,
  "Metallurgical Engineering": metallurgical,
  "Physiology": physical_science,
  "resource_and_conservation": resource_and_conservation,
  "transportation": transportation,
  "Utilities": utilities,
  "Wholesale Trade": wholesale_trade,
  "Miscellaneous Fine Arts": fine_arts,
  "Physiology": physiology,
  "Personal And Culinary Services": culinary,
  "Rotc/Military Technologies": militatry_tech,
  "Construction Trades": construction,
  "Natural Resources And Conservation": natural_resouces, 
  "Science Technologies/Technicians": technicians,
  "Transportation And Materials Moving": transportation,
  "Library Science": library,
  "Security And Protective Services": security_and_protection,
}

class LeafletMap extends Component {
  static defaultProps = {
    zoomControlPosition: 'topleft'
  }

  constructor(props) {
    super(props)
    this.state = {
      zoomSnap: 0.1,
      currentCenter: [34.6, -111.7],
    }
  }

  onEachFeature = (feature, layer) => {
    const fillColor = this.props.navTitle === "Education" ? "#6AA4DC63" : "#FB6A5963" // fill colour
    layer.setStyle({
      weight: 4,
      fill: true,
      fillColor: fillColor,
      color: this.props.navTitle === "Education" ? "#489FDC" : "#FB6A59", // boundary colour
      fillOpacity: 1,
    });
  }
  
  render() {
    const north = [37.215241, -115.793825]
    const south = [31.038470, -107.969698]
    const mybounds = L.latLngBounds(north, south);
    const isScreen1 = this.props.variable === 'screen1'
    const label = this.props.label;
    const title = <span>{label}</span>;
    const content = renderTooltipContent(label);

    return (
      <div className="leaflet-container">
        <Map
          center={this.state.currentCenter}
          zoom={this.props.minZoom}
          zoomSnap={this.state.zoomSnap}
          zoomControl={false}
          doubleClickZoom={false}
          scrollWheelZoom={false}
          minZoom={this.props.minZoom}
          maxZoom={10}
          maxBounds={mybounds}
        >
          {/* <Legend /> */}
          <TileLayer url={"https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"} maxBounds={mybounds} />
          <GeoJSON
            ref={(r) => {
              this._geoJSON = r;
            }}
            key={Math.random()}
            data={azBoundary}
            onEachFeature={this.onEachFeature}
            // style={{ weight: 10, zindex: 1, color: '#489FDC' }}
          />
          {azBoundary.features.map((el, ind) => {
            if (this.props.mapsData && this.props.mapsData[el.properties.NAME] !== "") {
              var icon = L.icon({
                iconUrl: ICONS_MAPPING[this.props.mapsData[el.properties.NAME]] ? ICONS_MAPPING[this.props.mapsData[el.properties.NAME]] : ICONS_MAPPING["default_icon"],
                iconSize: [50, 50],
                iconAnchor: [0, 0],
                popupAnchor: null,
                shadowUrl: null,
                shadowSize: null,
                shadowAnchor: null
              })
              // var LatLng = L.polygon(el.geometry.coordinates).getCenter();
              var i, j, x = 0, y = 0;
              for (i = 0, j = el.geometry.coordinates[0].length - 1; i < el.geometry.coordinates[0].length; j=i,i++) {
                var point1 = el.geometry.coordinates[0][i];
                var point2 = el.geometry.coordinates[0][j];
                var f = point1[0] * point2[1] - point2[0] * point1[1];
                x += (point1[0] + point2[0]) * f;
                y += (point1[1] + point2[1]) * f;
              }
              var area = 0;
              for (i = 0, j = el.geometry.coordinates[0].length - 1; i < el.geometry.coordinates[0].length; j=i,i++) {
                point1 = el.geometry.coordinates[0][i];
                point2 = el.geometry.coordinates[0][j];
                area += point1[0] * point2[1];
                area -= point1[1] * point2[0];
              }
              area *= 3;
              return (
              <Marker icon={icon} key={ind} position={[y/area+0.28, x/area-0.28]}>
                <Tooltip opacity="1">
                  <b>{this.props.mapsData[el.properties.NAME]}</b> is the most specialized or concentrated 
                  {this.props.navTitle === "Education" ? " degree " : " industry "} 
                  in <b>{el.properties.NAME}</b>
                </Tooltip>
              </Marker>
              )
            }
            else {
              return (<div key={ind} style={{display: "none"}}></div>)
            }
          })}
        </Map>
      </div>
    );
  }
}

export default LeafletMap;
